module.exports = "https://cdn2-fs.clearscore.com/flux/images/f514c3823afbc3331549e3c8335dccb1.jpg";